"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSpacer = exports.Overlay = exports.EuraSider = exports.EuraOverlay = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const EuraRahastoTag_1 = require("./EuraRahastoTag");
require("../styles/eura-overlay.css");
require("../styles/eura-navigation-spacer.css");
const Icons_1 = require("./Icons");
const EuraLogout_1 = require("./EuraLogout");
const { Header, Content, Sider, Footer } = antd_1.Layout;
const Icon = (props) => {
    return react_1.default.Children.map(props.children, (child) => {
        return react_1.default.cloneElement(child, { className: 'top-menu-logo-container__logo' });
    });
};
const Title = (props) => {
    const { title, url = '/' } = props;
    return (react_1.default.createElement("h1", { "data-testid": 'top.title', className: 'top-menu-title-container__text-container top-menu-title-container__item' },
        react_1.default.createElement("a", { "data-testid": 'top.title.link', className: 'top-menu-title-container__text', href: url }, title)));
};
const RahastoTag = (props) => {
    const { dataTestId, eakrTyyppi } = props, other = __rest(props, ["dataTestId", "eakrTyyppi"]);
    return (react_1.default.createElement("div", { className: eakrTyyppi === 'YRTU' || eakrTyyppi === 'TYT'
            ? 'top-menu-container__label-container eakr-margin-top'
            : 'top-menu-container__label-container' },
        react_1.default.createElement(EuraRahastoTag_1.EuraRahastoTag, Object.assign({ dataTestId: 'top.label', eakrTyyppi: eakrTyyppi }, other))));
};
const PageInfo = (props) => {
    return (react_1.default.createElement("div", { className: 'top-menu-container__page-info-container' },
        react_1.default.createElement("span", { "data-testid": 'top.pageinfo.top', className: props.pageInfoBottom
                ? 'top-menu-container__page-info-container__top-item'
                : 'top-menu-container__page-info-container__middle-item' }, props.pageInfoTop),
        react_1.default.createElement("span", { "data-testid": 'top.pageinfo.bottom', className: 'top-menu-container__page-info-container__bottom-item' }, props.pageInfoBottom)));
};
const UserInfo = (props) => {
    return (react_1.default.createElement("div", { className: 'top-menu-container__user-info-container' },
        react_1.default.createElement("span", { "aria-label": props.ariaLabelTop, "data-testid": 'top.userinfo.top', className: props.sijainen ? 'top-menu-container__user-info-container__top-item1' : 'top-menu-container__user-info-container__top-item' }, props.userInfoTop),
        props.sijainen && (react_1.default.createElement("span", { className: 'top-menu-container__user-info-container__top-item2' },
            react_1.default.createElement(Icons_1.SIcon, null))),
        react_1.default.createElement("span", { "aria-label": props.ariaLabelBottom, "data-testid": 'top.userinfo.bottom', className: props.sijainen
                ? 'top-menu-container__user-info-container__bottom-item-wide'
                : 'top-menu-container__user-info-container__bottom-item' }, props.userInfoBottom)));
};
const RightContent = (props) => {
    var _a;
    const classConstruct = ['top-menu-container__menu-container', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement("div", { "data-testid": props.dataTestId, className: classConstruct.join(' ') }, props.children));
};
const MiddleContent = (props) => {
    var _a;
    const classConstruct = ['top-menu-container__middle-container', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return react_1.default.createElement("div", { className: classConstruct.join(' ') }, props.children);
};
const LeftContent = (props) => {
    var _a;
    const leftClassConstruct = ['top-menu-title-container', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return react_1.default.createElement("div", { className: leftClassConstruct.join(' ') }, props.children);
};
/**
 * Overlay-komponentti. Yläpalkissa on kolme paikkaa sisällölle. Vasemmassa reunassa on paikka ikonille.
 * Yläpalkin alla vasemmalla puolella on paikka sisällölle.
 * @param props
 * @param props.rightContent Oikeaan reunaan menevä sisältö. Pieni alue.
 * @param props.leftContent Vasempaan reunaan menevä sisältö. Pieni alue.
 * @param props.middleContent Keskelle menevä sisältö. Isoin alue yläpalkissa.
 * @param props.bottomContent Headerin loppuun menevä sisältö.
 * @param props.footerContent Overlayn childrenien alle menevä sisältö.
 * @param props.icon Vasempaan reunaan menevä ikoni.
 * @param props.sider Yläpalkin alle vasemmalle menevä sisältö.
 * @param props.children sider-sisällön oikealle puolelle menevä sisältö.
 * @param props.rightContentClassName oikean puolen sisällön className
 * @param props.leftContentClassName vasemman puolen sisällön className
 * @param props.className Yläpalkin className
 * @param props.logoutLocalizations uloskirjautumista varten tarvittavat käännökset
 * @param props.logoutUrl uloskirjatumiseen käytettävä urli
 */
const EuraOverlay = (props) => {
    return (react_1.default.createElement(exports.Overlay, { footerContent: props.footerContent, icon: props.icon || react_1.default.createElement(Icons_1.EuraIcon, null), className: props.className, sider: props.sider, headerContent: react_1.default.createElement(react_1.default.Fragment, null,
            props.leftContent && react_1.default.createElement(LeftContent, { className: props.leftContentClassName }, props.leftContent),
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(MiddleContent, null, props.middleContent ? props.middleContent : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(EuraLogout_1.EuraLogout, { localizations: props.logoutLocalizations, logoutUrl: props.logoutUrl })),
            props.rightContent && (react_1.default.createElement(RightContent, { dataTestId: 'top.menu.container', className: props.rightContentClassName }, props.rightContent)),
            props.bottomContent) }, props.children));
};
exports.EuraOverlay = EuraOverlay;
const EuraSider = (props) => {
    var _a;
    const classConstruct = ['overlay-sider', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement(Sider, { id: props.id, role: props.role, "aria-label": props.ariaLabel, className: classConstruct.join(' ') }, props.children));
};
exports.EuraSider = EuraSider;
const Overlay = (props) => {
    var _a;
    const classConstruct = ['top-menu-container', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement(antd_1.Layout, null,
        react_1.default.createElement(Header, { role: 'banner', className: classConstruct.join(' ') },
            props.icon && (react_1.default.createElement("div", { className: 'top-menu-logo-container' },
                react_1.default.createElement(Icon, null, props.icon))),
            props.headerContent),
        react_1.default.createElement(antd_1.Layout, null,
            props.sider,
            react_1.default.createElement(antd_1.Layout, { className: (props.sider ? 'overlay-content-layout__padding ' : '') + 'overlay-content-layout' },
                react_1.default.createElement(Content, { role: 'main' }, props.children),
                react_1.default.createElement(Footer, { role: 'contentinfo', className: 'overlay-footer' }, props.footerContent)))));
};
exports.Overlay = Overlay;
/**
 * Tilanjakajapalkki, joka on tarkoitettu Overlay-komponentin ja varsinaisen sisällön väliin. Näyttää mariannekuvioisen
 * värinauhan testiympäristössä. Tuotannossa nauha on näkyvissä vain virkailijoille, joka korostaa että ollaan
 * virkailijoiden palvelussa.
 * @param isProduction Ollaanko tuotannossa vai ei.
 * @param isVirkailija Onko kyseessä virkailijan puoli
 * @param localizations Tekstiresurssit nauhan sisältämille teksteille
 */
const NavigationSpacer = ({ env, isVirkailija, localizations, ryhmahankeTag }) => {
    const { testiEnvInfoText = '', koulutusEnvInfoText = '', viranomainenText = '', hakijaText = '', ryhmahankeText = '', paahankeText = '', osahankeText = '', } = localizations || {};
    const userMode = isVirkailija ? 'virkailija' : 'hakija';
    const envMode = env.isProduction ? 'prod' : env.isTraining ? 'training' : 'test';
    const line1XPos = env.isTraining ? 68 : 50;
    const line2XPos = env.isTraining ? 34 : 25;
    const testTextXPos = ryhmahankeTag ? 12 : 15;
    const testTextYPos = ryhmahankeTag ? 16 : 12;
    const visible = ryhmahankeTag || isVirkailija || !env.isProduction;
    if (ryhmahankeTag) {
        document.body.style.setProperty('--navigation-spacer-korkeus', '1.8rem');
    }
    else if (!visible) {
        document.body.style.setProperty('--navigation-spacer-korkeus', '0rem');
    }
    else {
        document.body.style.setProperty('--navigation-spacer-korkeus', '1.2rem');
    }
    return visible ? (react_1.default.createElement("div", { className: `navigation-spacer navbar-background-${envMode}-${userMode}` },
        !env.isProduction && (react_1.default.createElement("span", { className: 'navbar-test-container' },
            react_1.default.createElement("svg", { className: 'navbar-svg-container' },
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("pattern", { id: 'pinstripe', patternTransform: 'rotate(45)', patternUnits: 'userSpaceOnUse', width: '100', height: '10' },
                        react_1.default.createElement("line", { className: `line-first-${envMode}-${userMode}`, x1: line1XPos, y1: '0', x2: line1XPos, y2: '50' }),
                        react_1.default.createElement("line", { className: `line-second-${envMode}-${userMode}`, x1: line2XPos, y1: '0', x2: line2XPos, y2: '50' })),
                    react_1.default.createElement("pattern", { id: 'Text', patternUnits: 'userSpaceOnUse', width: '141.5', height: '20' },
                        react_1.default.createElement("text", { x: testTextXPos, y: testTextYPos, className: `navbar-env-text ${isVirkailija && env.isTraining ? 'navbar-env-text-color-training-virkailija' : 'navbar-env-text-color-default'}` }, env.isTraining ? koulutusEnvInfoText : testiEnvInfoText))),
                react_1.default.createElement("rect", { fill: 'url(#pinstripe)', width: '100%', height: '100%' }),
                react_1.default.createElement("rect", { fill: 'url(#Text)', width: '100%', height: '100%' })))),
        ryhmahankeTag && ryhmahankeTag,
        (isVirkailija || env.isTraining) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: 'navbar-ryhmahanke-space-middle' }),
            react_1.default.createElement("span", { className: `navbar-usergroup-text navbar-usergroup-text-${userMode}` }, isVirkailija ? viranomainenText : hakijaText))))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.NavigationSpacer = NavigationSpacer;
exports.EuraOverlay.Sider = exports.EuraSider;
exports.EuraOverlay.MiddleContent = MiddleContent;
exports.EuraOverlay.RightContent = RightContent;
exports.EuraOverlay.LeftContent = LeftContent;
exports.EuraOverlay.Overlay = exports.Overlay;
exports.EuraOverlay.Title = Title;
exports.EuraOverlay.RahastoTag = RahastoTag;
exports.EuraOverlay.PageInfo = PageInfo;
exports.EuraOverlay.UserInfo = UserInfo;
exports.EuraOverlay.NavigationSpacer = exports.NavigationSpacer;
